import { downloadEncodedUri } from "./downloadEncodedUri";

export const downloadBlob = (filename: string, blob: Blob) => {
  const blobUrl = window.URL.createObjectURL(blob);

  downloadEncodedUri({
    filename: filename,
    encodedUri: blobUrl,
  });

  window.URL.revokeObjectURL(blobUrl);
};
